import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastController, ModalController } from '@ionic/angular';
import { ValidationCodeService, PortabilityKeysService, ClaimsKeysPixService } from '@wlp/ui-bs-pix';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { UiCSendCodeAccountActivationComponent } from '@wlp/ui-c-send-code-account-activation';
import { Subscription } from 'rxjs';
// import { AuthService } from 'src/app/core/auth/auth-service';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { ModalPixManagementKeyComponent } from 'src/app/views/themes/sentinel/modals/modal-pix-management-key/modal-pix-management-key.component';
import { UserInfoService } from '@wlp/ui-bs-login';
import { LoadingService } from './../../../../../../../../core/layout/services/loading.service';
import { ModalPixRefusedComponent } from './../../../../../modals/modal-pix-refused/modal-pix-refused.component';

@Component({
  selector: 'app-code-validation',
  templateUrl: './code-validation.page.html',
  styleUrls: ['./code-validation.page.scss'],
})
export class CodeValidationPage implements OnInit {
  @Input() key: string;
  @Input() type: string;

  celPhone: string;
  sub: Subscription;
  errorMessages: any;
  formSendCode: FormGroup;
  progressbarValue: number;
  accountMigration: any;
  @ViewChild('cd', { static: false }) public sendCode: UiCSendCodeAccountActivationComponent;

  modal: HTMLIonModalElement;
  backgroundImage: any;
  portabilityForm: FormGroup;
  /* key: any; */
  keyTextType: string;
  cdr: any;
  userProfile: any;
  typeKey: string;
  code: any;
  /* keyType: any; */
  params: { keyValue: any; keyType: string };
  wlName: any;
  typeClaim: any;
  keyFormated: any;
  isCpfCnpj = false;

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  constructor(
    private sendCodeService: ValidationCodeService,
    private layoutConfigService: LayoutConfigService,
    private portabilityService: PortabilityKeysService,
    private authService: UserInfoService,
    private toastCrtl: ToastController,
    private load: LoadingService,
    private router: Router,
    private claimService: ClaimsKeysPixService,
    private modalController: ModalController,
    private translate: UiBsTranslateService
  ) {
    this.formSendCode = this.sendCodeService.getForm();
    this.sendCodeService.getErrorFormMessage();
    this.backgroundImage = this.layoutConfigService.getConfig('wlTheme.header.background.image');

    this.wlName = this.layoutConfigService.getConfig('wlTheme.wlName');
  }

  ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    this.loadUser();

    this.params = {
      keyValue: this.key,
      keyType: this.verifyTypeKey(this.type),
    };

    /* if (this.router.getCurrentNavigation().extras.state == undefined) {
      this.router.navigate(['/app/pix']);
    } else {
      this.key = this.router.getCurrentNavigation().extras.state['key'];

      this.keyType = this.router.getCurrentNavigation().extras.state['type'];
      this.typeClaim = this.router.getCurrentNavigation().extras.state['claimType'];

     
    } */
  }

  formSendCodeEmitter(event): void {}

  resetCode() {
    let body = this.sendCodeService.prepareRequest(
      this.userProfile.uuidWhiteLabel,
      this.userProfile.uuidAccount,
      this.type,
      this.key,
      ''
    );

    this.sendCodeService.createCode(body).subscribe(async (res: any) => {
      if (res) {
        const toast = await this.toastCrtl.create({
          message: res.message,
          duration: 3000,
          position: 'top',
        });
        toast.present();
      } else {
        const toast = await this.toastCrtl.create({
          message: res.message,
          duration: 3000,
          position: 'top',
        });
        toast.present();
      }
    });
  }

  continue() {
    this.prepareCode();

    let body = this.sendCodeService.prepareRequest(
      this.userProfile.uuidWhiteLabel,
      this.userProfile.uuidAccount,
      this.type,
      this.key,
      this.code
    );

    this.sendCodeService.validationCode(body).subscribe(async (res: any) => {
      if (res.status) {
        this.modal.dismiss(res.status, this.code);
      } else {
        const toast = await this.toastCrtl.create({
          message: res.message,
          duration: 3000,
          position: 'top',
        });
        toast.present();
      }
    });
  }

  prepareCode() {
    this.code = `${this.formSendCode.controls.codeNumberOne.value}${this.formSendCode.controls.codeNumberTwo.value}${this.formSendCode.controls.codeNumberThree.value}${this.formSendCode.controls.codeNumberFour.value}${this.formSendCode.controls.codeNumberFive.value}`;
  }

  verifyTypeKey(type: any) {
    switch (type) {
      case 'CPF': {
        this.isCpfCnpj = true;
        return 'CPF/CNPJ';
      }
      case 'CNPJ': {
        return 'CPF/CNPJ';
      }
      case 'PHONE': {
        this.keyFormated = this.key.replace('+55', '');
        return 'Telefone';
      }
      case 'EMAIL': {
        return 'Email';
      }
    }
  }

  loadUser() {
    this.authService.getInfoProfile().then(
      (res) => {
        this.userProfile = res;
        this.resetCode();
      },
      () => {
        this.cdr.detectChanges();
      }
    );
  }

  formIsValid() {
    if (this.formSendCode.status === 'VALID') {
      return true;
    } else {
      return false;
    }
  }

  creatClaim() {
    const claimRequest = {
      uuidAccountPayment: this.userProfile.uuidAccount,
      keyType: this.type,
      key: this.key,
      claimType: this.typeClaim,
    };

    const params = {
      key: this.key,
      wlName: this.wlName,
    };

    this.claimService.createConfirm(claimRequest).subscribe((res) => {
      if (res.status === 'CREATED') {
        this.modalNotification(
          'PIX.PORTABILITY_KEYS.CODE_VALIDATION.MESSAGES.TITLE',
          'PIX.PORTABILITY_KEYS.CODE_VALIDATION.MESSAGES.MESSAGE',
          null,
          'PIX.PORTABILITY_KEYS.CODE_VALIDATION.BUTTON',
          false,
          null,
          false,
          false,
          params
        ).then((res) => {
          if (res) {
            this.router.navigate(['/app/pix/manage-keys']);
          }
        });
      } else {
        this.modalCardNotificationError(null, res.message, 'PIX.PORTABILITY_KEYS.CODE_VALIDATION.CLOSE_BUTTON', true, 'warning-circle');
      }
    });
  }

  async modalNotification(
    title: string,
    subtitle: string,
    dismissText: string,
    confirmText: string,
    imageModal: boolean,
    imageTag: string,
    doubleButton: boolean,
    clearButton: boolean,
    params: Object
  ) {
    const modal = await this.modalController.create({
      component: ModalPixManagementKeyComponent,
      cssClass: 'modal-pix-management-key-class-small',
      componentProps: {
        title,
        subtitle,
        dismissText,
        confirmText,
        imageModal,
        imageTag,
        doubleButton,
        clearButton,
        params,
      },
    });
    await modal.present();
    return await modal.onWillDismiss();
  }

  async modalCardNotificationError(title, subtitle, textButton, imageModal, imageTag) {
    const modal = await this.modalController.create({
      component: ModalPixRefusedComponent,
      cssClass: 'modal-custom-class',
      componentProps: {
        title,
        subtitle,
        textButton,
        imageModal,
        imageTag
      },
    });
    return await modal.present();
  }

  goBack() {
    this.modal.dismiss(false);
  }
}
